module.exports = __webpack_public_path__ + "img/antes_despues_193.29b6eb86.png";